module.exports = function getResource(label, vars = []) {
    let resources = {
        addToCal: 'Ajouter au calendrier',
        cancel: 'Annuler',
        reschedule: 'Changer la date',
        copyLinkShare: 'Copier le lien suivant pour partager',
        share: 'Partager',
        cancelReservation: 'Annuler la réservation'
    };

    return resources[label];
};
